<script src="update-my-profile.component.ts"></script>
<h1>
  <a class="home-non-link">
    <i class="fa fa-home" aria-hidden="true"></i>
    {{'My Profile' | translate}}
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="container-content" fxLayout fxLayoutAlign="space-between start">
    <form [formGroup]="getUpdateMyProfileForm()" class="ng" fxLayout="column" fxFlex novalidate
          (ngSubmit)="updateProfile(getUpdateMyProfileForm().value)">

      <div *ngIf="getLoggedInUserProfile().customerNumber" class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="customerNr" class="control-label" fxFlex="30">
          {{'Customer-no' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border has-danger"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['customerNr'].disabled}"
            name="customerNr" id="customerNr"
            formControlName="customerNr">
        </div>
      </div>

      <div *ngIf="getLoggedInUserProfile().customerNumber" class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="company" class="control-label" fxFlex="30">
          {{'Company' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['company'].disabled}"
            maxlength="50"
            name="company" id="company"
            formControlName="company">
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="title" class="control-label" fxFlex="30">
          {{'Title' | translate}}
        </label>
        <div class="input-container" fxLayout="column" [ngClass]="{'disabled': getUpdateMyProfileForm().controls['title'].disabled}" fxFlex>
          <ng-select
            [items]="getListOfTitles()"
            bindLabel="label"
            bindValue="value"
            [ngClass]="{'select-with-value': getSelectWithInitialValue()}"
            [searchable]="false"
            (selected)="onSelected($event)"
            (deselected)="onDeselected($event)"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="title"
          ></ng-select>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="firstName" class="control-label" fxFlex="30">
          {{'First name' | translate}} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['firstName'].disabled}"
            maxlength="20"
            name="firstName" id="firstName"
            formControlName="firstName">
          <div
            *ngIf="getUpdateMyProfileForm().controls['firstName'].errors && (getUpdateMyProfileForm().controls['firstName'].dirty || getUpdateMyProfileForm().controls['firstName'].touched)">
            <small [hidden]="!getUpdateMyProfileForm().controls['firstName'].errors.required" class="feedback">
              {{'Required' | translate}}.
            </small>
            <small [hidden]="!getUpdateMyProfileForm().controls['firstName'].errors.minlength" class="feedback">
              {{'It should be at least 2 characters long' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="lastName" class="control-label" fxFlex="30">
          {{'Last name' | translate}} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['lastName'].disabled}"
            name="lastName" id="lastName"
            maxlength="40"
            formControlName="lastName">
          <div
            *ngIf="getUpdateMyProfileForm().controls['lastName'].errors && (getUpdateMyProfileForm().controls['lastName'].dirty || getUpdateMyProfileForm().controls['lastName'].touched)">
            <small class="feedback" [hidden]="!getUpdateMyProfileForm().controls['lastName'].errors.required">
              {{'Required' | translate}}.
            </small>
            <small [hidden]="!getUpdateMyProfileForm().controls['lastName'].errors.minlength" class="feedback">
              {{'It should be at least 2 characters long' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="birthDate" class="control-label" fxFlex="30">
          {{'Date of birth' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <date-picker-input
            [formGroup]="getUpdateMyProfileForm()"
            formControlName="birthDate"
            [clearInput]="!getReadonly()"
            [calendarIcon]="!getReadonly()"
            ngDefaultControl>
          </date-picker-input>
          <div
            *ngIf="getUpdateMyProfileForm().controls['birthDate'].errors && (getUpdateMyProfileForm().controls['birthDate'].dirty || getUpdateMyProfileForm().controls['birthDate'].touched)">
            <small class="feedback" [hidden]="!getUpdateMyProfileForm().controls['birthDate'].errors.ngbDate">
              {{'Date format must be yyyy-mm-dd' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="email" class="control-label" fxFlex="30">
          {{'E-mail' | translate}} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            class="form-control"
            maxlength="50"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['email'].disabled}"
            name="email" id="email"
            formControlName="email">
          <div
            *ngIf="getUpdateMyProfileForm().controls['email'].errors && (getUpdateMyProfileForm().controls['email'].dirty || getUpdateMyProfileForm().controls['email'].touched)">
            <small [hidden]="!getUpdateMyProfileForm().controls['email'].errors.required" class="feedback">
              {{'Required' | translate}}
            </small>
            <small [hidden]="!getUpdateMyProfileForm().controls['email'].errors.pattern" class="feedback">
              {{'Email must have the format john.doe@example.com' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="phone" class="control-label" fxFlex="30">
          {{'Phone number' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['phone'].disabled}"
            maxlength="20"
            name="phone" id="phone"
            formControlName="phone">
          <div
            *ngIf="getUpdateMyProfileForm().controls['phone'].errors && (getUpdateMyProfileForm().controls['phone'].dirty || getUpdateMyProfileForm().controls['phone'].touched)">
            <small [hidden]="!getUpdateMyProfileForm().controls['phone'].errors.pattern" class="feedback">
              {{'Please enter a valid phone number' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="postalCode" class="control-label" fxFlex="30">
          {{'PostalCode' | translate}}
          <span *ngIf="postalCodeRequired">*</span>
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex>
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              id="postalCode"
              maxlength="10"
              formControlName="postalCode">
          </div>
          <div fxLayout="column" class="feedback-wrapper"
              *ngIf="getUpdateMyProfileForm().controls['postalCode'].errors && (getUpdateMyProfileForm().controls['postalCode'].dirty || getUpdateMyProfileForm().controls['postalCode'].touched)">
            <small [hidden]="!getUpdateMyProfileForm().controls['postalCode'].errors.required" class="feedback">
              {{'Required' | translate}}.
            </small>
            <small [hidden]="!getUpdateMyProfileForm().controls['postalCode'].errors.pattern" class="feedback">
              {{'PostalCode format not valid' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="countryCode" class="control-label" fxFlex="30">
          {{'Country' | translate}} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <ng-select
            [items]="getListOfCountries()"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngClass]="{'select-with-value': getSelectWithInitialValue()}"
            [minTermLength]="3"
            (selected)="onSelected($event)"
            (deselected)="onDeselected($event)"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="countryCode">
          </ng-select>
          <div
            *ngIf="getUpdateMyProfileForm().controls['countryCode'].errors && (getUpdateMyProfileForm().controls['countryCode'].dirty || getUpdateMyProfileForm().controls['countryCode'].touched)">
            <small [hidden]="!getUpdateMyProfileForm().controls['countryCode'].errors.required" class="feedback">
              {{'Required' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="language" class="control-label" fxFlex="30">
          {{'Language' | translate}} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <ng-select
            [items]="getListOfLanguages()"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngClass]="{'select-with-value': getSelectWithInitialValue()}"
            [searchable]="false"
            (selected)="onSelected($event)"
            (deselected)="onDeselected($event)"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="language">
          </ng-select>
          <div
            *ngIf="getUpdateMyProfileForm().controls['language'].errors && (getUpdateMyProfileForm().controls['language'].dirty || getUpdateMyProfileForm().controls['language'].touched)">
            <small [hidden]="!getUpdateMyProfileForm().controls['language'].errors.required" class="feedback">
              {{'Required' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="avatar" class="control-label" fxFlex="30">
          {{'Avatar' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex [ngStyle]="{'height': '102px'}"
             [ngClass]="{'invalid-photo': getUpdateMyProfileForm().errors && (getUpdateMyProfileForm().errors.invalidImageType || getUpdateMyProfileForm().errors.invalidImageSize)}">

          <div class="add-photo-container" fxLayout="column" fxLayoutAlign="space-between end">
            <div class="photo-icon-container avatar"
                 [ngClass]="{'existing-photo': getUpdateMyProfileForm().controls.avatar.value || getLoggedInUserProfile().avatar}">
              <i
                [ngClass]="{'d-none': getUpdateMyProfileForm().controls.avatar.value || getLoggedInUserProfile().avatar}"
                class="fa fa-camera fa-lg" aria-hidden="true"></i>
              <div class="crop round-crop"
                   [ngClass]="{'d-none': getUpdateMyProfileForm().controls.avatar.value == null && !getLoggedInUserProfile().avatar}">
                <img [src]="getLoggedInUserProfile().avatar" [width]="100" [height]="100" [style.object-fit]='"cover"'>
              </div>
            </div>
            <div *ngIf="!getReadonly()" class="input-button-container" [ngClass]="{'two-buttons': getLoggedInUserProfile().avatar}">
              <label for="avatar">
                <div
                  *ngIf="!getUpdateMyProfileForm().controls.avatar.value && !getLoggedInUserProfile().avatar">{{'Add a photo' | translate}}</div>
                <div
                  *ngIf="getUpdateMyProfileForm().controls.avatar.value || getLoggedInUserProfile().avatar">{{'Change photo' | translate}}</div>
              </label>
              <input
                  #fileInput
                  type="file"
                  class="fileInput"
                  id="avatar" name="avatar"
                  accept="image/*"
                  (change)="fileChangeEvent($event)">
            </div>

            <div class="remove-button-container"
                 *ngIf="!getReadonly() && (getUpdateMyProfileForm().controls.avatar.value || getLoggedInUserProfile().avatar)">
              <div class="remove-image-btn" (click)="deleteAvatar()">{{'Remove avatar' | translate}}</div>
            </div>
          </div>
          <div class="feedback-wrapper photo" *ngIf="getUpdateMyProfileForm().errors" fxLayout="column">
            <small class="feedback">
              {{'Invalid image' | translate}}.
            </small>
            <small class="feedback" [hidden]="!getUpdateMyProfileForm().errors.invalidImageType">
              {{'Please choose from one of the following image formats: jpg, jpeg, png, giff' | translate}}.
            </small>
            <small class="feedback" [hidden]="!getUpdateMyProfileForm().errors.invalidImageSize">
              {{'The maximum photo size can be 2MBs' | translate}}.
            </small>
          </div>
        </div>
      </div>

      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [roundCropper]="true"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>

      <div *ngIf="getLoggedInUserProfile().customerNumber" class="form-group" fxLayout fxLayout.xs="column">
        <label for="companyLogo" class="control-label" fxFlex="30">
          {{'Company logo' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex [ngStyle]="{'height': '102px'}">

          <div class="add-photo-container for-logo" fxLayout fxLayoutAlign="end center">
            <div class="photo-icon-container"
                 [ngClass]="{'existing-photo': getUpdateMyProfileForm().controls.companyLogo.value || getLoggedInUserProfile().companyLogo}">
              <i [ngClass]="{'d-none': getLoggedInUserProfile().companyLogo}" class="fa fa-camera fa-lg"
                 aria-hidden="true"></i>
              <div class="crop" [ngClass]="{'d-none': !getLoggedInUserProfile().companyLogo}" fxLayout="column"
                   fxLayoutAlign="center center">
                <img [src]="getLoggedInUserProfile().companyLogo" [width]="getCompanyLogoWidth()">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div *ngIf="getLoggedInUserProfile().customerNumber" class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="contactPerson" class="control-label" fxFlex="30">
          {{'Contact person' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control"
            [ngClass]="{'disabled': getUpdateMyProfileForm().controls['contactPerson'].disabled}"
            name="contactPerson" id="contactPerson"
            formControlName="contactPerson">
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="authorization" class="control-label" fxFlex="30">
          {{'Authorizations' | translate}}
        </label>
        <div class="input-container disabled" fxLayout="column" fxFlex>
          <ng-select
            [items]="getListOfRoles()"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [multiple]="true"
            formControlName="roles">
          </ng-select>
        </div>
      </div>

      <!-- Temporarily disabled (https://itsm.slx.de/jira/browse/UMNG-552) -->
      <!--div class="form-group" fxLayout="row" fxLayout.xs="column">
        <span class="control-label" fxFlex="30"></span>
        <div class="input-container" fxLayout="column" fxFlex="70">
          <label for="wantsNewsletter">
            <input
              type="checkbox"
              class="checkbox"
              id="wantsNewsletter"
              name="wantsNewsletter"
              formControlName="wantsNewsletter"> {{'Subscribe to Newsletter' | translate}}</label>
          <div *ngIf="getNewsletterVerificationPending()" fxLayout>
            *{{'Newsletter confirmation pending' | translate}}
            <button class="btn btn-secondary" type="button" (click)="resendNewsletterSubscriptionLink()">
              {{'Resend me the email' | translate}}
            </button>
          </div>
        </div>
      </div-->

      <div class="divider"></div>

      <div class="buttons-group" fxLayout fxLayout.xs="column" fxLayoutGap="10px"
           fxLayoutAlign="space-around center" fxLayoutAlign.xs="space-between center">
        <button class="btn btn-success save-btn" type="submit" [disabled]="getUpdateMyProfileForm().invalid">
          {{'Update profile' | translate}}
        </button>
        <button *ngIf="!getReadonly()" class="btn btn-secondary" type="button" (click)="navigateToChangePassword()">
          {{'Change password' | translate}}
        </button>
        <app-delete-modal
          *ngIf="!getReadonly()"
          [whichPage]="'profile'"
          (onHide)="deleteMyProfile($event)">
        </app-delete-modal>
      </div>

    </form>

  </div>
</div>
<div class="divider"></div>
